export const styles = (theme) => ({
  dialogTitle: {
    textAlign: 'center' as const,
  },
  highlightText: {
    fontWeight: 400
  }
})
